import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { Controller, useController } from 'react-hook-form';
import ReactSelect from 'react-select';
import { useCreate, useNotify } from 'react-admin';

const QuillTextEditor = ({ control, source, dataFieldOptions }) => {
    const quillRef = useRef(null);
    const quillInstanceRef = useRef(null);
    const [create,result]=useCreate();
    const notify = useNotify();
    async function uploadImage(file) {

        return new Promise((resolve, reject) => {
            notify('Uploading Image', 'info');
            create('uploadFileToBlob', { data: file },
                {
                
                    onSuccess: (data) => {
                        notify('Image Uploaded', 'info');
                        resolve(data.url);

                    },
                    onFailure: (error) => {
                        notify('Error: uploading image', 'error');
                        reject(error);
                    },
                }
            )
        });
    }

    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/png, image/jpeg');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
                // Perform file upload logic here, for example, using FormData and fetch.
                // After uploading, you should have the image URL.
                const uploadedImageUrl = await uploadImage(file);

                // Use the Quill instance from quillInstanceRef
                const range = quillInstanceRef.current.getSelection(true);
                quillInstanceRef.current.insertEmbed(range.index, 'image', uploadedImageUrl);
            } else {
                alert('Only JPG and PNG images are allowed!');
            }
        };
    };
    const {
        field,
        fieldState: { error },
    } = useController({
        name: source,
        control,
    });
    const [dataFieldEnabled, setDataFieldEnabled] = useState(false);
    useEffect(() => {
        const isEmpty = !quillInstanceRef?.current?.root?.innerHTML.trim() || quillInstanceRef?.current?.root?.innerHTML === '<p><br></p>';

        if (isEmpty) {
            // Set the default value because the editor is empty
            quillInstanceRef?.current?.clipboard?.dangerouslyPasteHTML(0, field.value);
        }
    }, [field.value])

    function customButtonHandler() {
        setDataFieldEnabled(value => !value);
    }

    useEffect(() => {
        if (quillRef.current) {
            const editor = new Quill(quillRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                            ['blockquote', 'code-block'],

                            [{ 'header': 1 }, { 'header': 2 }], // custom button values
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
                            [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
                            [{ 'direction': 'rtl' }], // text direction

                            [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
                            // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
                            [{ 'font': [] }],
                            [{ 'align': [] }],

                            ['clean'], // remove formatting button
                            ['link', 'image'], // link and image, video
                            ['undo', 'redo'],
                        ],
                        handlers: {
                            'image': imageHandler,
                            'undo': function () {
                                this.quill.history.undo();
                            },
                            'redo': function () {
                                this.quill.history.redo();
                            }
                        }
                    },
                    history: {
                        delay: 2000,
                        maxStack: 500,
                        userOnly: true
                    }
                }
            });

            // editor.clipboard.dangerouslyPasteHTML(0, field.value);

            const handleChange = () => {
                const text = editor.root.innerHTML;
                console.log(text, typeof (text));

                field.onChange(text);
            };

            editor.on('text-change', handleChange);

            quillInstanceRef.current = editor;

            const customButton = document.createElement('button');
            customButton.type = 'button';
            customButton.className = 'ql-custom ql-formats';
            customButton.style.width = '90px';
            customButton.innerHTML = `<svg width="87" height="16" viewBox="0 0 87 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4498_2)">
      <path d="M7.33337 7.33203V3.33203H8.66671V7.33203H12.6667V8.66536H8.66671V12.6654H7.33337V8.66536H3.33337V7.33203H7.33337Z" fill="#303030" />
    </g>
    <path d="M29.4268 8.40723C29.4268 9.53288 29.2171 10.474 28.7979 11.2305C28.3786 11.9824 27.7702 12.5498 26.9727 12.9326C26.1751 13.3109 25.2135 13.5 24.0879 13.5H21.3125V3.50586H24.3887C25.4232 3.50586 26.3164 3.69271 27.0684 4.06641C27.8203 4.43555 28.4014 4.9847 28.8115 5.71387C29.2217 6.43848 29.4268 7.33626 29.4268 8.40723ZM27.7178 8.45508C27.7178 7.63477 27.5879 6.96029 27.3281 6.43164C27.0729 5.90299 26.6947 5.51107 26.1934 5.25586C25.6966 4.99609 25.0837 4.86621 24.3545 4.86621H22.9531V12.126H24.1152C25.3229 12.126 26.2253 11.8184 26.8223 11.2031C27.4193 10.5879 27.7178 9.67188 27.7178 8.45508ZM34.3828 5.78906C35.3398 5.78906 36.0622 6.00098 36.5498 6.4248C37.042 6.84863 37.2881 7.50944 37.2881 8.40723V13.5H36.1465L35.8389 12.4268H35.7842C35.57 12.7002 35.349 12.9258 35.1211 13.1035C34.8932 13.2812 34.6289 13.4134 34.3281 13.5C34.0319 13.5911 33.6696 13.6367 33.2412 13.6367C32.79 13.6367 32.3867 13.5547 32.0312 13.3906C31.6758 13.222 31.3955 12.9668 31.1904 12.625C30.9854 12.2832 30.8828 11.8503 30.8828 11.3262C30.8828 10.5469 31.1722 9.96126 31.751 9.56934C32.3343 9.17741 33.2139 8.96094 34.3896 8.91992L35.7021 8.87207V8.47559C35.7021 7.9515 35.5791 7.5778 35.333 7.35449C35.0915 7.13118 34.7497 7.01953 34.3076 7.01953C33.9294 7.01953 33.5625 7.07422 33.207 7.18359C32.8516 7.29297 32.5052 7.42741 32.168 7.58691L31.6484 6.45215C32.0176 6.25618 32.4368 6.09668 32.9062 5.97363C33.3802 5.85059 33.8724 5.78906 34.3828 5.78906ZM35.6953 9.88379L34.7178 9.91797C33.9157 9.94531 33.3529 10.082 33.0293 10.3281C32.7057 10.5742 32.5439 10.9115 32.5439 11.3398C32.5439 11.7135 32.6556 11.987 32.8789 12.1602C33.1022 12.3288 33.3962 12.4131 33.7607 12.4131C34.3167 12.4131 34.777 12.2559 35.1416 11.9414C35.5107 11.6224 35.6953 11.1553 35.6953 10.54V9.88379ZM42.3535 12.3379C42.5632 12.3379 42.7705 12.3197 42.9756 12.2832C43.1807 12.2422 43.3675 12.1943 43.5361 12.1396V13.3564C43.3584 13.4339 43.1283 13.5 42.8457 13.5547C42.5632 13.6094 42.2692 13.6367 41.9639 13.6367C41.5355 13.6367 41.1504 13.5661 40.8086 13.4248C40.4668 13.279 40.1956 13.0306 39.9951 12.6797C39.7946 12.3288 39.6943 11.8434 39.6943 11.2236V7.15625H38.6621V6.43848L39.7695 5.87109L40.2959 4.25098H41.3076V5.93262H43.4746V7.15625H41.3076V11.2031C41.3076 11.5859 41.4033 11.8708 41.5947 12.0576C41.7861 12.2445 42.0391 12.3379 42.3535 12.3379ZM48.041 5.78906C48.998 5.78906 49.7204 6.00098 50.208 6.4248C50.7002 6.84863 50.9463 7.50944 50.9463 8.40723V13.5H49.8047L49.4971 12.4268H49.4424C49.2282 12.7002 49.0072 12.9258 48.7793 13.1035C48.5514 13.2812 48.2871 13.4134 47.9863 13.5C47.6901 13.5911 47.3278 13.6367 46.8994 13.6367C46.4482 13.6367 46.0449 13.5547 45.6895 13.3906C45.334 13.222 45.0537 12.9668 44.8486 12.625C44.6436 12.2832 44.541 11.8503 44.541 11.3262C44.541 10.5469 44.8304 9.96126 45.4092 9.56934C45.9925 9.17741 46.8721 8.96094 48.0479 8.91992L49.3604 8.87207V8.47559C49.3604 7.9515 49.2373 7.5778 48.9912 7.35449C48.7497 7.13118 48.4079 7.01953 47.9658 7.01953C47.5876 7.01953 47.2207 7.07422 46.8652 7.18359C46.5098 7.29297 46.1634 7.42741 45.8262 7.58691L45.3066 6.45215C45.6758 6.25618 46.0951 6.09668 46.5645 5.97363C47.0384 5.85059 47.5306 5.78906 48.041 5.78906ZM49.3535 9.88379L48.376 9.91797C47.5739 9.94531 47.0111 10.082 46.6875 10.3281C46.3639 10.5742 46.2021 10.9115 46.2021 11.3398C46.2021 11.7135 46.3138 11.987 46.5371 12.1602C46.7604 12.3288 47.0544 12.4131 47.4189 12.4131C47.9749 12.4131 48.4352 12.2559 48.7998 11.9414C49.1689 11.6224 49.3535 11.1553 49.3535 10.54V9.88379ZM58.623 13.5H56.9961V3.50586H62.6426V4.88672H58.623V8.00391H62.3828V9.37793H58.623V13.5ZM65.9033 5.93262V13.5H64.2969V5.93262H65.9033ZM65.1104 3.03418C65.3564 3.03418 65.5684 3.10026 65.7461 3.23242C65.9284 3.36458 66.0195 3.59245 66.0195 3.91602C66.0195 4.23503 65.9284 4.46289 65.7461 4.59961C65.5684 4.73177 65.3564 4.79785 65.1104 4.79785C64.8551 4.79785 64.6387 4.73177 64.4609 4.59961C64.2878 4.46289 64.2012 4.23503 64.2012 3.91602C64.2012 3.59245 64.2878 3.36458 64.4609 3.23242C64.6387 3.10026 64.8551 3.03418 65.1104 3.03418ZM71.2217 5.78906C71.8962 5.78906 72.4749 5.92806 72.958 6.20605C73.4411 6.48405 73.8125 6.87826 74.0723 7.38867C74.332 7.89909 74.4619 8.50977 74.4619 9.2207V10.082H69.4102C69.4284 10.8158 69.6243 11.3809 69.998 11.7773C70.3763 12.1738 70.9049 12.3721 71.584 12.3721C72.0671 12.3721 72.5 12.3265 72.8828 12.2354C73.2702 12.1396 73.6689 12.0007 74.0791 11.8184V13.124C73.7008 13.3018 73.3158 13.4316 72.9238 13.5137C72.5319 13.5957 72.0625 13.6367 71.5156 13.6367C70.7728 13.6367 70.1188 13.4932 69.5537 13.2061C68.9932 12.9144 68.5534 12.4814 68.2344 11.9072C67.9199 11.333 67.7627 10.6198 67.7627 9.76758C67.7627 8.91992 67.9062 8.19987 68.1934 7.60742C68.4805 7.01497 68.8838 6.5638 69.4033 6.25391C69.9229 5.94401 70.529 5.78906 71.2217 5.78906ZM71.2217 6.99902C70.7158 6.99902 70.3057 7.16309 69.9912 7.49121C69.6813 7.81934 69.499 8.30013 69.4443 8.93359H72.8896C72.8851 8.55534 72.8213 8.22038 72.6982 7.92871C72.5798 7.63704 72.3975 7.40918 72.1514 7.24512C71.9098 7.08105 71.5999 6.99902 71.2217 6.99902ZM77.8867 13.5H76.2734V2.86328H77.8867V13.5ZM82.7266 13.6367C81.8242 13.6367 81.0996 13.3086 80.5527 12.6523C80.0104 11.9915 79.7393 11.0186 79.7393 9.7334C79.7393 8.43457 80.015 7.45247 80.5664 6.78711C81.1224 6.12174 81.8538 5.78906 82.7607 5.78906C83.1436 5.78906 83.4785 5.84147 83.7656 5.94629C84.0527 6.04655 84.2988 6.18327 84.5039 6.35645C84.7135 6.52962 84.8913 6.72331 85.0371 6.9375H85.1123C85.0895 6.79622 85.0622 6.59342 85.0303 6.3291C85.0029 6.06022 84.9893 5.81185 84.9893 5.58398V2.86328H86.6025V13.5H85.3447L85.0576 12.4678H84.9893C84.8525 12.6865 84.6794 12.8848 84.4697 13.0625C84.2646 13.2357 84.0186 13.3747 83.7314 13.4795C83.4489 13.5843 83.1139 13.6367 82.7266 13.6367ZM83.1777 12.3311C83.8659 12.3311 84.3512 12.1328 84.6338 11.7363C84.9163 11.3398 85.0622 10.7451 85.0713 9.95215V9.74023C85.0713 8.89258 84.9346 8.24316 84.6611 7.79199C84.3877 7.33626 83.8887 7.1084 83.1641 7.1084C82.5853 7.1084 82.1432 7.3431 81.8379 7.8125C81.5371 8.27734 81.3867 8.92676 81.3867 9.76074C81.3867 10.5947 81.5371 11.2327 81.8379 11.6748C82.1432 12.1123 82.5898 12.3311 83.1777 12.3311Z" fill="#303030" />
    <defs>
      <clipPath id="clip0_4498_2">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>`;
            // Ensure you replace "path/to/your/icon.png" with the actual path to your icon image

            // Step 2: Add the Custom Button to the Toolbar
            const toolbar = editor.getModule('toolbar');
            toolbar.addHandler('custom', customButtonHandler); // Assuming customButtonHandler is your click handler function
            toolbar.container.appendChild(customButton);



            customButton.addEventListener('click', customButtonHandler);
            // Add custom buttons to the toolbar
            const customUndoButton = document.createElement('button');
            customUndoButton.type = 'button';
            customUndoButton.className = 'ql-custom ql-formats';
            // customUndoButton.style.width = '90px';
            customUndoButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-arrow-counterclockwise"  viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
</svg>`; // You can replace this with an icon
            customUndoButton.classList.add('ql-undo');
            customUndoButton.addEventListener('click', () => {
                editor.history.undo();
            });

            const customRedoButton = document.createElement('button');
            customRedoButton.type = 'button';
            customRedoButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
</svg>`; // You can replace this with an icon
            customRedoButton.className = 'ql-custom ql-formats';
            // customRedoButton.style.width = '90px';
            customRedoButton.classList.add('ql-redo');
            customRedoButton.addEventListener('click', () => {
                editor.history.redo();
            });

            // Append buttons to the toolbar
            const toolbarContainer = toolbar.container;
            toolbarContainer.appendChild(customUndoButton);
            toolbarContainer.appendChild(customRedoButton);
            toolbar.container.prepend(customUndoButton);
            toolbar.container.prepend(customRedoButton);
            toolbar.container.prepend(customButton);

            return () => {
                editor.off('text-change', handleChange);
                customButton.removeEventListener('click', customButtonHandler);
            };

        }
    }, []);

    return (
        <div className="text_editor">
            {<div className={`d-flex justify-content-between ${!dataFieldEnabled ? 'd-none' : ''}`} >
                <div style={{ width: '300px' }} >
                    <ReactSelect onChange={(selected) => {
                        const range = quillInstanceRef.current.getSelection(true);
                        quillInstanceRef.current.insertText(range.index, selected.value);
                    }} options={dataFieldOptions} />
                </div>
                <p>&nbsp;</p>
            </div>}
            <div ref={quillRef} onChange={(html) => console.log(html)} />
            <div className="emp-inputs form-label">
                <div
                    className="invalid-feedback"
                    style={{ display: "block", fontSize: "70%" }}
                >
                    {error !== undefined && error.message}
                </div>
            </div>

        </div>
    );
};

export default QuillTextEditor;